import type {
  ApplovinUserData,
  InvoiceCardProps,
  TinyPayloads,
} from '@openeducation/pp-rn-shared-types';

export function formatApplovinEventData(invoiceCardProps: InvoiceCardProps) {
  // https://developers.applovin.com/en/audience-plus/events-and-objects#category-ids
  const itemCategoryId: number = 317;
  // The total already includes the quantity. AppLovin expects
  // value = price x quantity, so the price is the unit price.
  const { quantity, total: value } = invoiceCardProps;
  return {
    items: [
      {
        item_id: invoiceCardProps.id,
        item_name: invoiceCardProps.name,
        item_category_id: itemCategoryId,
        price: Math.round((value / quantity) * 100) / 100,
        quantity,
      },
    ],
    value,
    currency: invoiceCardProps.currency,
  };
}

// The AppLovin user_id: the Salesforce lead id, or else the purchaser account
// id (a converted lead, or an upsell). AG uses the same rule for the
// Conversion API.
export function getApplovinUserId(
  tinyPayloads?: Pick<TinyPayloads, 'sfdcLeadId' | 'salesForcePurchaserId'>
): string | undefined {
  return (
    tinyPayloads?.sfdcLeadId || tinyPayloads?.salesForcePurchaserId || undefined
  );
}

// The pixel hashes the email. AppLovin asks for it in lowercase.
export function formatApplovinUserData(
  email?: string,
  userId?: string
): ApplovinUserData {
  const normalizedEmail = email?.trim().toLowerCase();
  return {
    ...(normalizedEmail ? { email: normalizedEmail } : {}),
    ...(userId ? { user_id: userId } : {}),
  };
}
